import ORDER_STATUS from '../constants/orderStatus';

const toRusError = (e) => {
  switch (e) {
    case ORDER_STATUS.IS_NOT_IN_TIME:
      return 'Опаздывает';
    case ORDER_STATUS.INVALID_ADDRESS:
      return 'Неверный адрес';
    case ORDER_STATUS.SCHEDULE_VIOLATIONS:
      return 'Нарушен график';
    case ORDER_STATUS.OVERLOAD:
      return 'Перегруз';
    case ORDER_STATUS.OK:
      return 'Ошибок нет';
    case ORDER_STATUS.WORK_SHIFT_TIME_NOT_EXIST:
      return 'Рабочей смены не существует';
    case ORDER_STATUS.LOADING_AFTER_WORK_SHIFT:
      return 'Погрузка после рабочей смены';
    case ORDER_STATUS.LOADING_BEFORE_WORK_SHIFT:
      return 'Погрузка перед рабочей сменой';
    case ORDER_STATUS.DELIVERY_AFTER_WORK_SHIFT:
      return 'Доставка после рабочей смены';
    case ORDER_STATUS.DELIVERY_BEFORE_WORK_SHIFT:
      return 'Доставка перед рабочей сменой';
    case ORDER_STATUS.ARRIVAL_TIME_NOT_EXIST:
      return 'Время прибытия не существует';
    case ORDER_STATUS.LATE_ARRIVAL:
      return 'Позднее прибытие';
    case ORDER_STATUS.EARLIER_ARRIVAL:
      return 'Раннее прибытие';

    default:
      return 'Ошибка не найдена';
  }
};

export default toRusError;
